module.exports = __webpack_public_path__ + "static/media/software-image.2640d3d2.png";